<header
  class="em-c-header em-c-header--blue em-c-header--condensed"
  role="banner"
>
  <div class="em-l-container em-c-header__inner top-bar-container">
    <div class="em-c-header__body">
      <div class="em-c-header__title-container">
        <h2 class="em-c-header__title">
          <a [routerLink]="['']" rel="home" class="em-c-header__title-link">
            Chemical IT | Entitlement | ver. Global
          </a>
        </h2>
      </div>
      <!-- end em-c-header__left -->
      <button
        class="em-c-btn em-c-btn--small em-c-btn--inverted em-c-header__nav-btn em-js-nav-trigger"
      >
        <div class="em-c-btn__inner">
          <svg
            class="em-c-icon em-c-icon--small em-c-btn__icon em-js-btn-icon"
            data-em-btn-toggle-text="Close"
            data-em-icon-path="assets/unity-1.6.0/images/em-icons.svg"
          >
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/unity-1.6.0/images/em-icons.svg#hamburger"
            ></use>
          </svg>
          <svg
            class="em-c-icon em-c-icon--small em-c-btn__icon em-u-is-hidden em-js-btn-swap-icon"
            data-em-icon-path="assets/unity-1.6.0/images/em-icons.svg"
          >
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/unity-1.6.0/images/em-icons.svg#x-filled"
            ></use>
          </svg>
          <span class="em-c-btn__text em-js-btn-label">Menu</span>
        </div>
      </button>
      <!-- end em-c-btn -->
      <div class="em-c-header__nav-container em-js-nav-panel">
        <nav id="nav" class="em-c-primary-nav" role="navigation">
          <ul class="em-c-primary-nav__list">
            <li class="em-c-primary-nav__item">
              <a routerLink="" class="em-c-primary-nav__link"> Home </a>
            </li>
            <li class="em-c-primary-nav__item">
              <a routerLink="service" class="em-c-primary-nav__link">
                Service
              </a>
            </li>
            <li class="em-c-primary-nav__item">
              <a routerLink="client" class="em-c-primary-nav__link"> Client </a>
            </li>
            <li class="em-c-primary-nav__item">
              <a
                routerLink="document/api-document"
                class="em-c-primary-nav__link"
              >
                API Specification
              </a>
            </li>
          </ul>
          <!-- end em-c-nav__list -->
        </nav>
        <!-- end em-c-nav -->
      </div>
      <!-- end em-c-header__nav -->
    </div>
    <!-- end em-c-header__body -->

    <span
      class="em-c-tooltip em-c-tooltip--icon em-c-tooltip--below em-js-tooltip"
    >
      <span class="em-c-tooltip__trigger em-js-tooltip-trigger">
        @if ((storeService.user$ | async)?.imageURL) {
          <img
            src="{{ (storeService.user$ | async)?.imageURL }}"
            alt="{{ (storeService.user$ | async)?.name }}"
            class="em-c-avatar top-bar-avatar"
          />
        }
        @if (!(storeService.user$ | async)?.imageURL) {
          <svg
            class="em-c-icon em-c-icon--medium top-bar-temp-avatar"
            data-em-icon-path="../../../../assets/unity-1.6.0/images/em-icons.svg"
          >
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="../../../../assets/unity-1.6.0/images/em-icons.svg#user-1"
            ></use>
          </svg>
        }
      </span>
      <span class="em-c-tooltip__content profile-tooltip-content">
        <p>{{ (storeService.user$ | async)?.name }}</p>
      </span>
    </span>
  </div>
  <!-- end em-l-container -->
</header>
